



















































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import InputUTXO from '@/components/rows/TxRow/InputUtxo.vue'
import OutputUTXO from '@/components/rows/TxRow/OutputUtxo.vue'
import {
    Transaction,
    getTransactionOutputs,
    getTransactionInputs,
} from '@/js/Transaction'
import { DEFAULT_NETWORK_ID } from '@/store/modules/network/network'
import { getTxChainType } from '@/known_blockchains'
import { getMappingForType } from '@/store/modules/transactions/maps'

@Component({
    components: {
        InputUTXO,
        OutputUTXO,
    },
    filters: {
        getType: getMappingForType,
    },
})
export default class TxRow extends Vue {
    @Prop() transaction!: Transaction

    get isGenesisVertex(): boolean {
        const genesisTxID =
            DEFAULT_NETWORK_ID === 1
                ? process.env.VUE_APP_AVAXID
                : process.env.VUE_APP_TEST_AVAXID
        return this.transaction.id === genesisTxID ? true : false
    }

    get chainCode() {
        return getTxChainType(this.transaction.chainID)!.code
    }

    get chainColor() {
        return getTxChainType(this.transaction.chainID)!.color
    }

    get chainDarkColor() {
        return getTxChainType(this.transaction.chainID)!.darkColor
    }

    get type() {
        return getMappingForType(this.transaction.type)
    }

    /**
     * Returns a list of unique addresses found in Input UTXOs
     */
    get inputs() {
        const addresses = getTransactionInputs(this.transaction.inputs).flatMap(
            (output) => output.output.addresses
        )

        /**
         * This is just making sure that the addresses is a unique set with no repeats
         */
        return Array.from(
            new Set(addresses.map((address) => address.address))
        ).map((address) => {
            return {
                address,
                ...addresses.find((a) => a.address === address),
            }
        })
    }

    get outputs() {
        return getTransactionOutputs(this.transaction.outputs)
    }

    goToTx() {
        this.$router.push(`/tx/${this.transaction.id}`)
    }
}
